export default __webpack_public_path__ + "static/media/LightMode.a81b3683.png";